import { Suspense } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import * as Sentry from '@sentry/react';
import ForYouCharacters from '~/components/Main/ForYouCharacters/ForYouCharacters';
import ExploreCharacters from '~/components/MoreOneOnOne/ExploreCharacters/ExploreCharacters';
import { FlexStack } from '~/components/atomic';
import { HelmetHead } from '~/components/common';
import MoreOneOnOneSkeleton from '~/components/common/Skeleton/MoreOneOnOneSkeleton';
import { breakpoint } from '~/styles/themes';

export default function MoreOneOnOne() {
  return (
    <>
      <HelmetHead title='Chat' />

      <Suspense fallback={<MoreOneOnOneSkeleton />}>
        <Container>
          <FlexStack spacing={24}>
            <FlexStack
              css={css`
                padding-left: 16px;
              `}
            >
              <Sentry.ErrorBoundary fallback={undefined}>
                <ForYouCharacters />
              </Sentry.ErrorBoundary>
            </FlexStack>

            <FlexStack
              css={css`
                padding: 0 16px;
              `}
            >
              <Sentry.ErrorBoundary fallback={undefined}>
                <ExploreCharacters />
              </Sentry.ErrorBoundary>
            </FlexStack>
          </FlexStack>
        </Container>
      </Suspense>
    </>
  );
}

const Container = styled.div`
  max-width: ${breakpoint.mobile_large};
  margin: 0 auto;
  padding-top: calc(${(props) => props.theme.layout.chat_header_height} + 24px);
  padding-bottom: calc(
    ${(props) => props.theme.layout.chat_navigation_height} + 16px
  );
`;
